import { Node, ReactFlowInstance } from '@xyflow/react';
import { useCallback } from 'react';
import { FLOW_KEY } from '../../../../../constants/constants';

export const useSaveFlow = (rfInstance: ReactFlowInstance | null, nodes: Node[]) => {
    const onSave = useCallback(() => {
        if (rfInstance) {
            const flow = rfInstance.toObject();
            const nodesWithStyles = nodes.map((node) => ({
                ...node,
                data: {
                    ...node.data,
                    style: node.style,
                },
            }));
            flow.nodes = nodesWithStyles;
            localStorage.setItem(FLOW_KEY, JSON.stringify(flow));
        }
    }, [rfInstance, nodes]);

    return { onSave };
};
